"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariant = void 0;
const enums_1 = require("../enums");
const variantMap = {
    [enums_1.ProductType.Box]: enums_1.Variant.Box,
    [enums_1.ProductType.ValueVoucher]: enums_1.Variant.ValueVoucher,
    [enums_1.ProductType.GiftWrap]: enums_1.Variant.GiftWrap,
};
function getVariant(appointment, productType) {
    if (!!productType && productType !== enums_1.ProductType.Experience) {
        return variantMap[productType];
    }
    if (!appointment?.appointmentId && !appointment?.locationId && !appointment?.reservationId) {
        return enums_1.Variant.ExperienceVoucher;
    }
    return enums_1.Variant.ExperienceTicket;
}
exports.getVariant = getVariant;
//# sourceMappingURL=getVariant.js.map